import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

interface UserInvitationCardProps {
  invitedByUserName: string;
  invitedAt: string;
  formatDateTime: (dateString: string) => string;
}

export function UserInvitationCard({
  invitedByUserName,
  invitedAt,
  formatDateTime,
}: UserInvitationCardProps) {
  return (
    <Card variant="outlined" data-testid="user-invitation-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MailOutlineIcon fontSize="small" color="action" />
            <Typography variant="h6" component="h3">
              Invitation Details
            </Typography>
          </Box>

          {/* Invitation Details */}
          <Stack spacing={1}>
            {/* Invited By */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Invited By
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {invitedByUserName}
              </Typography>
            </Box>

            {/* Date & Time */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Date & Time
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {formatDateTime(invitedAt)}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
